import { Button, Button as MUIButton, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, TextField, Tooltip } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import moment from "moment";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
  Show,
  Tab,
  TabbedShowLayoutTabs,
  useRecordContext,
  useRefresh,
  useResourceContext,
  useShowContext,
} from "react-admin";
import ChefForPartyMetaShow from "./ChefForPartyMetaShow";
import { useState } from "react";
import AssignCookOnChefForParty from "../Common/AssignCookOnChefForParty";
import { EditDishesChefForParty } from "../Common/EditDishesChefForParty";
import ChefForPartyCancelDialog from "../Common/ChefForPartyCancelDialog";
import UpdateCommentInChefForParty from "../Common/UpdateCommentInChefForParty";
import ChefForPartyReScheduleDialog from "../Common/ChefForPartyReScheduleDialog";
import ChefForPartOrderTab from "./ChefForPartOrderTab";
import { useLocation, useNavigate } from "react-router-dom";
import ChefForPartCooksTab from "./ChefForPartyCooksTab";
import ChangeCouponChefForPartyDialog from "../Common/ChangeCouponChefForPartyDailog";
import { PaymentStatusEnum } from "../../enums/PaymentStatusEnum";
import ChefForPartStatusEnum from "../../enums/ChefForPartStatusEnum";
import ChefForPartyService from "../../services/ChefForPartyService";
import { useAppSelector } from "../../store/hooks";
import GroupPermissionFunction from "../../utils/groupPermissionFunction";
import { UserGroupsEnum } from "../../enums/UserGroupsEnum";
import UpdatePartyRemainingPaymentStatusDialog from "../Common/UpdatePartyRemainingPaymentStatusDialog";
import ChefOrderSummaryDialog from "../Common/ChefOrderSummaryDialog";
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";
import ChefForPartyIngredientList from "./ChefForPartyIngredientList";
import AddIngredientDialog from "../Common/AddIngredientDialog";
import UpdateOccasionDialog from "../Common/UpdateOccasionDialog";
import AddPartyPreferencesDialog from "../Common/AddPartyPreferencesDialog";
import CookAdditionalDetails from "../Cooks/CookAdditionalDetails";
import ChangeOmsTimeDialog from "../Common/ChangeOmsTimeDialog";
import OneMealVendorPayoutTab from "../OneMealService/OneMealVendorPayoutTab";
import PartyServiceAllocationTab from "./PartyServiceAllocationTab";
import UpdateLeadTagDialog from "../Common/UpdateLeadTagDailog";
import UpdateOMSStatusDialog from "../Common/UpdateOMSStatusDialog";
import ReferenceSosAlertsTable from "../Common/ReferenceSosAlertsTable";
import {
  ButtonContainer,
  SectionTitleRow,
  ShowTabsContainer,
  WorkspaceContainer,
  WorkspaceHeader,
  WorkspaceIconBadge,
  WorkspaceTitle,
  ShowLabel,
  ShowValue,
  InfoPill,
  HighlightValue,
} from "../../styles/commonStyles";
import { colors } from "../../styles/colors";
import { ChefCapIcon } from "../Svg/ChefCapIcon";
import OmsDeniedCookList from "../OneMealService/OmsDeniedCookList";
import { moduleType } from "../../enums/common";
import CustomerCallRecordingsTab from "../Customers/CustomerCallRecordingsTab";
import { CallMaskingReferenceModelNameEnum } from "../../enums/CallMaskingReferenceModelNameEnum";
import ServiceCallLogsTab from "../Common/ServiceCallLogsTab";
import ServiceRefundsTab from "../Common/ServiceRefundsTab";
import ServiceNotificationsTab from "../Common/ServiceNotificationsTab";
import CookAuditLogs from "../Cooks/CookAuditLogs";

import { CookService } from "../../services/CookServices";
import CookIncentiveDialog from "../Common/CookIncentiveDialog";
import UpdateBookByDishVisitChargesDialog from "../Common/UpdateBookByDishVisitChargesDialog";
import { ChefForPartyBookingTypeEnum } from "../../enums/ChefForPartyBookingTypeEnum";

const chefForPartyService = new ChefForPartyService();
const cookService = new CookService();
interface InputProps {
  name: any;
  callback: (data: any) => void;
  disabled?: boolean;
  color?:
    | "inherit"
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning"
    | undefined;
}

const CustomButton = (props: InputProps) => {
  let record = useRecordContext();
  return (
    <MUIButton
      onClick={() => {
        props.callback(record);
      }}
      disabled={props.disabled}
      size={"small"}
      color={props.color || "secondary"}
      variant={"contained"}
      style={{ width: "max-content", fontSize: "12px" }}
    >
      {props.name}
    </MUIButton>
  );
};

const ChefForPartyTab = () => {
  let location = useLocation();
  let partyId = location.pathname.split("/")[2];
  let record = useRecordContext();

  return (
    <ShowTabsContainer
      tabs={
        <TabbedShowLayoutTabs
          variant="scrollable"
          scrollButtons="auto"
          selectionFollowsFocus={true}
        />
      }
    >
      <Tab label={"Details"} key={"Details"}>
        <ChefForPartyMetaShow />
      </Tab>
      <Tab label={"Allocation Tab"} key={"Allocation Tab"}>
        <PartyServiceAllocationTab record={record} />
      </Tab>
      <Tab label={"Orders"} key={"Orders"}>
        <ChefForPartOrderTab partyId={parseInt(partyId)} />
      </Tab>
      <Tab label={"Cooks"} key={"Cooks"}>
        <ChefForPartCooksTab partyId={parseInt(partyId)} />
      </Tab>
      <Tab label={"Ingredient List"} key={"IngredientList"}>
        <ChefForPartyIngredientList ingredientList={record?.ingredientList} />
      </Tab>
      <Tab label={"Denied Cooks"} key={"Denied Cooks"}>
        <OmsDeniedCookList serviceId={Number(partyId)} type = {moduleType.CHEF_FOR_PARTY}/>
      </Tab>
      <Tab label={"Party Extra Details"}>
        <CookAdditionalDetails
          partyId={parseInt(partyId)}
          referenceModel="CHEF_FOR_PARTY"
        />
      </Tab>
      <Tab label={"Party Vendor Payouts"}>
        <OneMealVendorPayoutTab
          oneMealServiceId={Number(partyId)}
          forparty={true}
        />
      </Tab>
      <Tab label={"SOS Alerts"} key={"SOS Alerts"}>
        <ReferenceSosAlertsTable
          referenceId={Number(record?.id)}
          referenceModel={"CHEF_FOR_PARTY"}
        />
      </Tab>
      <Tab label={"Call Recordings"} key={"Call Recordings"}>
        <CustomerCallRecordingsTab serviceId={Number(record?.id)} referenceModalName={CallMaskingReferenceModelNameEnum.CHEF_FOR_PARTY}/>
      </Tab>
      <Tab label={"Call Logs"} key={"Call Logs"}>
        <ServiceCallLogsTab referenceId={Number(partyId)} referenceModelName={"CHEF_FOR_PARTY"} />
      </Tab>
      <Tab label={"Refunds"} key={"Refunds"}>
        <ServiceRefundsTab referenceId={Number(partyId)} referenceModel="CHEF_FOR_PARTY_ORDER" />
      </Tab>
      <Tab label={"Notifications"} key={"Notifications"}>
        <ServiceNotificationsTab referenceId={Number(partyId)} referenceModelName="CHEF_FOR_PARTY" />
      </Tab>
      <Tab label={"Audit Logs"} key={"Audit Logs"}>
        <CookAuditLogs referenceId={Number(partyId)} referenceModel="ChefForParty" />
      </Tab>
      {/*<Tab label={"Services"} key={"Services"}>*/}
      {/*<AreaServicesTab />*/}
      {/*</Tab>*/}
    </ShowTabsContainer>
  );
};

const CTAButtons = (props: any) => {
  const { record } = useShowContext();
  // Shared by the ChefForParty and BookByDish resources — navigate within the
  // current one so the sidebar highlight stays on the right module.
  const resource = useResourceContext();
  let navigate = useNavigate();
  const refresh = useRefresh();
  const userDetails = useAppSelector((state) => state.userDetails.value);
  let groupsArray: string[] = userDetails.adminUser.accessGroups;
  const [openAgentEtaDialog, setOpenAgentEtaDialog] = useState(false);
  const [agentEtaTime, setAgentEtaTime] = useState<any>(moment());
  const [openLunchMoneyDialog, setOpenLunchMoneyDialog] = useState(false);
  const [openFarVisitIncentiveDialog, setOpenFarVisitIncentiveDialog] = useState(false);
  const [openVisitChargesDialog, setOpenVisitChargesDialog] = useState(false);

  return (
    <div>
      <Stack direction={"row"} style={{ marginBottom: "10px" }} gap={2}>
        {![
          ChefForPartStatusEnum.CANCELLED,
          ChefForPartStatusEnum.RESCHEDULED,
          ChefForPartStatusEnum.FULFILLED,
        ].includes(record?.status) && [
          <CustomButton
            name={record?.bookingType === 'BOOK_BY_DISH' ? "Edit Book By Dish" : "Edit Chef For party"}
            color={"warning"}
            callback={(data) => {
              navigate(`/${resource}/${data?.id}`);
            }}
          />,
          <CustomButton
            name={"Assign Vendor"}
            color={"primary"}
            callback={(data) => {
              props.setSelectedData(data);
              props.setOpenAssignCook(true);
            }}
          />,
          ...(record?.bookingType !== 'BOOK_BY_DISH' ? [<CustomButton
            name={"Add Dishes"}
            color="primary"
            callback={(data: any) => {
              props.setSelectedData(data);
              props.setDishModel(true);
            }}
          />] : []),
          <>
            {record?.status === ChefForPartStatusEnum.ONGOING && (
              <CustomButton
                name={"Mark As FulFilled"}
                color="primary"
                callback={(data: any) => {
                  chefForPartyService.markAsFulFilled(data?.id).then(() => {
                    refresh();
                  });
                }}
              />
            )}
          </>,
          <>
            {record?.status === ChefForPartStatusEnum.CHEF_CONFIRMED && (
              <CustomButton
                name={"Mark As OnGoing"}
                color="primary"
                callback={(data: any) => {
                  chefForPartyService.markAsOnGoing(data?.id).then(() => {
                    refresh();
                  });
                }}
              />
            )}
          </>,
          <>
            {[
              PaymentStatusEnum.PAYMENT_IN_PROGRESS,
              PaymentStatusEnum.NOT_PAID,
            ].includes(record?.remainingAmountPaymentStatus) && (
              <CustomButton
                name={"Change Coupon"}
                color="primary"
                callback={(data: any) => {
                  props.setSelectedData(data);
                  props.setChangeCouponModel(true);
                }}
              />
            )}
            {GroupPermissionFunction(groupsArray, [UserGroupsEnum.ADMIN]) && (
              <CustomButton
                name={"Change Party Status"}
                color="primary"
                callback={(data: any) => {
                  props.setSelectedData(data);
                  props.setUpdateOMSStatusDialog(true);
                }}
              />
            )}
          </>,
          <CustomButton
            name={"Cancel Chef For Party"}
            color="error"
            callback={(data: any) => {
              props.setSelectedData(data);
              props.setCancelModel(true);
            }}
          />,
          <CustomButton
            name={"Reschedule Chef For Party"}
            color="error"
            callback={(data: any) => {
              props.setSelectedData(data);
              props.setReScheduleModel(true);
            }}
          />,
          <CustomButton
            name={
              record?.allowLatePayment
                ? "Not Allow Late Payment"
                : "Allow Late Payment"
            }
            color="error"
            callback={(data: any) => {
              EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
                message: record?.allowLatePayment
                  ? "Confirm not allow late payment?"
                  : "Confirm allow late payment?",
                onClose: (confirmed: boolean) => {
                  if (confirmed) {
                    chefForPartyService
                      .allowLatePaymet(record?.id)
                      .then((response) => {
                        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                          message: "Marked Successfully",
                          type: CustomSnackbarTypes.SUCCESS,
                        });
                        refresh();
                      });
                  }
                },
                title: "Confirmation",
              });
            }}
          />,
        ]}
        {![
          ChefForPartStatusEnum.CANCELLED,
          ChefForPartStatusEnum.RESCHEDULED,
          ChefForPartStatusEnum.FULFILLED,
        ].includes(record?.status) &&
          ![PaymentStatusEnum.PAID].includes(
            record?.remainingAmountPaymentStatus,
          ) &&
          GroupPermissionFunction(groupsArray, [UserGroupsEnum.ADMIN]) && (
            <CustomButton
              name={"Update Remaining Payment Status"}
              color="primary"
              callback={() => {
                props.setUpdateRemainingPaymentStatusDialog(true);
              }}
            />
          )}
        {/* {![
                ChefForPartStatusEnum.CANCELLED,
                ChefForPartStatusEnum.RESCHEDULED,
                ChefForPartStatusEnum.FULFILLED,
            ].includes(record?.status) && (
                <CustomButton
                    name={"Set Amount to be Collected"}
                    color="warning"
                    callback={(data: any) => {
                      EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
                        message: "Confirm setting amount to be collected to net payable amount?",
                        onClose: (confirmed: boolean) => {
                          if (confirmed) {
                            chefForPartyService.updatePartyAmountToBeCollected(record?.id).then((response) => {
                              EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                                message: "Marked Successfully",
                                type: CustomSnackbarTypes.SUCCESS,
                              });
                              refresh();
                            })
                          }
                        },
                        title: "Confirmation",
                      });
                    }}
                />
            )} */}
      </Stack>
      <Stack
        direction={"row"}
        style={{
          marginBottom: "10px",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "8px",
        }}
        gap={2}
      >
        {GroupPermissionFunction(groupsArray, [UserGroupsEnum.ADMIN]) &&
          record?.status !== ChefForPartStatusEnum.FULFILLED && (
            <CustomButton
              name={"Change Party Time"}
              color="primary"
              callback={(data: any) => {
                props.setSelectedData(data);
                props.setOneMealTimeUpdateDialog(true);
              }}
            />
          )}
        <CustomButton
          name={"Allocation Comment"}
          color="primary"
          callback={(data: any) => {
            props.setSelectedData(data);
            props.setUpdateCommentDialog(true);
            props.setInitiatedBy(1);
          }}
        />
        <CustomButton
          name={"Supply Comments"}
          color="primary"
          callback={(data: any) => {
            props.setSelectedData(data);
            props.setUpdateCommentDialog(true);
            props.setInitiatedBy(2);
          }}
        />
        <CustomButton
          name={"Customer Comments"}
          color="primary"
          callback={(data: any) => {
            props.setSelectedData(data);
            props.setUpdateCommentDialog(true);
            props.setInitiatedBy(3);
          }}
        />
        <CustomButton
          name={"View Order Summary"}
          color="success"
          callback={(data: any) => {
            props.setSelectedData(data);
            props.setOrderSummary(true);
          }}
        />
        <CustomButton
          name={"View Party Details"}
          color="success"
          callback={(data: any) => {
            props.setSelectedData(data);
            props.setCookOrderSummary(true);
          }}
        />
        <CustomButton
          name={"Generate Ingredient List"}
          color="success"
          callback={(data: any) => {
            chefForPartyService
              .generateIngredientsList(record?.id)
              .then((response) => {
                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                  message: "Generated successfully",
                  type: CustomSnackbarTypes.SUCCESS,
                });
                refresh();
                navigate(`/${resource}/${record?.id}/show/4`);
              });
          }}
        />
        <CustomButton
          name={
            record?.isIngredientListVerified
              ? "Mark Ingredient List Unverified"
              : "Verify Ingredient List"
          }
          color="success"
          callback={(data: any) => {
            const verificationStatus = !data?.isIngredientListVerified;

            EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
              message: verificationStatus
                ? "Confirm ingredient list verification?"
                : "Confirm removal of ingredient list verification?",
              onClose: (confirmed: boolean) => {
                if (confirmed) {
                  chefForPartyService
                    .updateIngredientListVerificationStatus(
                      data?.id,
                      verificationStatus
                    )
                    .then((response) => {
                      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                        message: verificationStatus
                          ? "Verified successfully"
                          : "Verification removed successfully",
                        type: CustomSnackbarTypes.SUCCESS,
                      });
                      refresh();
                      navigate(`/${resource}/${data?.id}/show/4`);
                    });
                }
              },
              title: "Confirmation",
            });
          }}
        />
        <CustomButton
          name={"Add Ingredient"}
          color="success"
          callback={(data: any) => {
            props.setSelectedData(data);
            props.setAddIngredientModel(true);
          }}
        />
        <CustomButton
          name={"Update occasion"}
          color="success"
          callback={(data: any) => {
            props.setSelectedData(data);
            props.setUpdateOccasionModel(true);
          }}
        />
        <CustomButton
          name={"Update Lead Tag"}
          color="success"
          callback={(data: any) => {
            props.setSelectedData(data);
            props.setOpenTagDialog(true);
          }}
        />
        <CustomButton
          name={"Add Preferences"}
          color={"primary"}
          callback={(data) => {
            props.setSelectedData(data);
            props.setAddPreferencesModel(true);
          }}
        />
        <CustomButton
          name={"Cash Collected"}
          color="error"
          callback={(data: any) => {
            EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
              message: "Confirm cash collected?",
              onClose: (confirmed: boolean) => {
                if (confirmed) {
                  chefForPartyService
                    .cashCollected(record?.id)
                    .then((response) => {
                      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                        message: "Marked Successfully",
                        type: CustomSnackbarTypes.SUCCESS,
                      });
                      refresh();
                    });
                }
              },
              title: "Confirmation",
            });
          }}
        />
        {[
          ChefForPartStatusEnum.CHEF_CONFIRMED,
          ChefForPartStatusEnum.CHEF_ALLOTTED,
          ChefForPartStatusEnum.FULFILLED,
          ChefForPartStatusEnum.ONGOING,
        ].includes(record?.status) && (
          <Button
            onClick={() => {
              const cookId = record?.cooks[0]?.details?.cookId;
              navigate(`/VisitTracker/CHEF_FOR_PARTY/${record?.id}/${cookId}`, {
                state: {
                  visitData: record,
                  cookId: record.cooks?.filter(
                    (cook: any) => cook.type === "MAIN_CHEF",
                  )[0]?.details?.cookId,
                },
              });
            }}
            variant="contained"
            color="success"
          >
            View Tracker
          </Button>
        )}
        <CustomButton
          name={"Convert To Full Payment"}
          color="success"
          callback={(data: any) => {
            EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
              message: "Convert To Full Payment Order?",
              onClose: (confirmed: boolean) => {
                if (confirmed) {
                  chefForPartyService
                    .convertToFullPaymentOrder(record?.id)
                    .then((response) => {
                      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                        message: "Converted Successfully",
                        type: CustomSnackbarTypes.SUCCESS,
                      });
                      window.location.reload();
                    });
                }
              },
              title: "Confirmation",
            });
          }}
        />
        <CustomButton
          name={"update Agent Expected ETA"}
          color="primary"
          callback={() => setOpenAgentEtaDialog(true)}
        />
        {record?.bookingType === ChefForPartyBookingTypeEnum.BOOK_BY_DISH &&
          ![
            ChefForPartStatusEnum.CANCELLED,
            ChefForPartStatusEnum.RESCHEDULED,
            ChefForPartStatusEnum.FULFILLED,
          ].includes(record?.status) && (
            <CustomButton
              name={"Update Visit Charges"}
              color="primary"
              callback={() => setOpenVisitChargesDialog(true)}
            />
          )}
        <Dialog
          open={openAgentEtaDialog}
          onClose={() => setOpenAgentEtaDialog(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Update Agent Expected Arrival Time</DialogTitle>
          <DialogContent>
            <Stack spacing={2} mt={1}>
              <DateTimePicker
                value={agentEtaTime}
                onChange={(newValue) => setAgentEtaTime(newValue)}
                onAccept={(newValue) => setAgentEtaTime(newValue)}
                views={["hours", "minutes"]}
                openTo="hours"
                disablePast
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    inputProps={{
                      ...params.inputProps,
                      value: agentEtaTime
                        ? moment(agentEtaTime).format("MM/DD/YYYY hh:mm A")
                        : (params.inputProps?.value || ""),
                    }}
                  />
                )}
              />
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenAgentEtaDialog(false)} color="secondary">
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={async () => {
                if (!agentEtaTime || !record?.id) {
                  EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                    message: "Please select a valid date & time",
                    type: CustomSnackbarTypes.ERROR,
                  });
                  return;
                }
                try {
                  await chefForPartyService.updateAgentEta(
                    Number(record.id),
                    moment(agentEtaTime).toISOString()
                  );
                  EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                    message: "Agent expected arrival time updated successfully",
                    type: CustomSnackbarTypes.SUCCESS,
                  });
                  setOpenAgentEtaDialog(false);
                  refresh();
                } catch (err: any) {
                  EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                    message: err?.response?.data?.error || err?.response?.data?.message || "Failed to update agent expected arrival time",
                    type: CustomSnackbarTypes.ERROR,
                  });
                }
              }}
            >
              Update
            </Button>
          </DialogActions>
        </Dialog>
        <CustomButton
          name={record?.isImportant ? "Unmark Important" : "Mark Important"}
          color={record?.isImportant ? "warning" : "inherit"}
          callback={(data: any) => {
            cookService
              .markVisitAsImportant(Number(record?.id), "CHEF_FOR_PARTY", !record?.isImportant)
              .then(() => {
                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                  message: record?.isImportant ? "Removed from important" : "Marked as important",
                  type: CustomSnackbarTypes.SUCCESS,
                });
                refresh();
              })
              .catch(() => {
                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                  message: "Failed to update importance",
                  type: CustomSnackbarTypes.ERROR,
                });
              });
          }}
        />
        {GroupPermissionFunction(groupsArray, [UserGroupsEnum.ADMIN]) && (
          <CustomButton
            name={"Remove Customer Rating"}
            color="error"
            callback={(data: any) => {
              const ratingId = data?.customerRatings?.[0]?.id;
              if (!ratingId) {
                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                  message: "No customer rating found for this visit",
                  type: CustomSnackbarTypes.ERROR,
                });
                return;
              }
              EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
                message: "Are you sure you want to remove the customer rating?",
                onClose: (confirmed: boolean) => {
                  if (confirmed) {
                    cookService.deleteCookRating(ratingId).then(() => {
                      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                        message: "Customer rating removed successfully",
                        type: CustomSnackbarTypes.SUCCESS,
                      });
                      refresh();
                    }).catch(() => {
                      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                        message: "Failed to remove customer rating",
                        type: CustomSnackbarTypes.ERROR,
                      });
                    });
                  }
                },
                title: "Confirmation",
              });
            }}
          />
        )}

        {/* {GroupPermissionFunction(groupsArray, [
          UserGroupsEnum.ADMIN,
          UserGroupsEnum.MANAGER,
        ]) && [
          <CustomButton
            key={"lunch-money"}
            name={"Lunch Money"}
            color={"success"}
            callback={() => setOpenLunchMoneyDialog(true)}
          />,
          <CustomButton
            key={"far-visit-incentive"}
            name={"Far Visit Incentive"}
            color={"success"}
            callback={() => setOpenFarVisitIncentiveDialog(true)}
          />,
        ]} */}

        {record?.bookingType === ChefForPartyBookingTypeEnum.BOOK_BY_DISH && (
          <UpdateBookByDishVisitChargesDialog
            open={openVisitChargesDialog}
            partyId={Number(record?.id)}
            currentVisitCharges={Number(record?.visitCharges ?? 0)}
            callback={(updated) => {
              setOpenVisitChargesDialog(false);
              if (updated) refresh();
            }}
          />
        )}

        <CookIncentiveDialog
          open={openLunchMoneyDialog}
          id={Number(record?.id)}
          serviceType={"party"}
          incentiveType={"lunchMoney"}
          callback={() => {
            setOpenLunchMoneyDialog(false);
            refresh();
          }}
        />

        <CookIncentiveDialog
          open={openFarVisitIncentiveDialog}
          id={Number(record?.id)}
          serviceType={"party"}
          incentiveType={"farVisitIncentive"}
          callback={() => {
            setOpenFarVisitIncentiveDialog(false);
            refresh();
          }}
        />
      </Stack>
    </div>
  );
};

const ChefForPartyHeaderWithRecord = () => {
  const record = useRecordContext();
  console.log("record from chef for party show: ", record);

  const getStatusColor = (status: string) => {
    switch (status) {
      case "FULFILLED":
        return { color: "rgb(21, 128, 61)", bg: "rgb(220, 252, 231)" };
      case "ONGOING":
        return { color: "rgb(29, 78, 216)", bg: "rgb(219, 234, 254)" };
      case "CHEF_CONFIRMED":
        return { color: "rgb(194, 65, 12)", bg: "rgb(255, 237, 213)" };
      case "CANCELLED":
        return { color: "rgb(185, 28, 28)", bg: "rgb(254, 226, 226)" };
      case "RESCHEDULED":
        return { color: "rgb(107, 33, 168)", bg: "rgb(233, 213, 255)" };
      default:
        return { color: "rgb(108, 124, 147)", bg: "rgb(241, 245, 249)" };
    }
  };

  const statusStyle = getStatusColor(record?.status);

  return (
    <WorkspaceHeader>
      <SectionTitleRow>
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <WorkspaceIconBadge>
              <ChefCapIcon color={'#fff'} width={24} height={24} />
            </WorkspaceIconBadge>
            <WorkspaceTitle style={{marginRight: '8px'}}>
              {record?.bookingType === 'BOOK_BY_DISH' ? 'Book by Dish' : 'Chef for Party'}
            </WorkspaceTitle>
            <ButtonContainer>
              <InfoPill
                style={{
                  backgroundColor: "rgba(38, 135, 35, .1)",
                  padding: "2px 12px",
                  border: `1px solid ${colors.green}`,
                  borderRadius: "100px",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <HighlightValue
                  style={{ fontSize: "12px", color: colors.green, margin: "0" }}
                >
                  #ID: {record?.id}
                </HighlightValue>
                <Tooltip title="Copy ID">
                  <IconButton
                    size="small"
                    onClick={() => navigator.clipboard.writeText(String(record?.id))}
                    sx={{ p: 0.25, color: colors.green }}
                  >
                    <ContentCopyIcon sx={{ fontSize: 13 }} />
                  </IconButton>
                </Tooltip>
              </InfoPill>
              <InfoPill
                style={{
                  backgroundColor: "rgb(237, 233, 254)",
                  padding: "2px 12px",
                  border: `1px solid rgb(109, 40, 217)`,
                  borderRadius: "100px",
                }}
              >
                <ShowLabel
                  style={{
                    color: "rgb(109, 40, 217)",
                    fontSize: "12px",
                    fontWeight: "bold",
                    marginBottom: "0px",
                  }}
                >
                  OTP:{" "}
                </ShowLabel>
                <HighlightValue
                  style={{
                    fontSize: "12px",
                    color: "rgb(109, 40, 217)",
                    margin: "0",
                  }}
                >
                  {record?.otp}
                </HighlightValue>
              </InfoPill>
            </ButtonContainer>
          </div>
        </div>
      </SectionTitleRow>
      <ButtonContainer>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "6px 12px",
            borderRadius: "8px",
            backgroundColor: statusStyle.bg,
            border: `1px solid ${statusStyle.color}20`,
          }}
        >
          <ShowLabel
            style={{
              fontSize: "12px",
              margin: "0",
              color: statusStyle.color,
              fontWeight: "500",
            }}
          >
            Status:
          </ShowLabel>
          <ShowValue
            style={{
              fontSize: "14px",
              margin: "0",
              color: statusStyle.color,
              fontWeight: "600",
              textTransform: "uppercase",
            }}
          >
            {record?.status || "UNKNOWN"}
          </ShowValue>
        </div>
        {record?.status === "CANCELLED" && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "2px",
              padding: "6px 12px",
              borderRadius: "8px",
              backgroundColor: statusStyle.bg,
              border: `1px solid ${statusStyle.color}20`,
            }}
          >
            {record?.cancellationReason && (
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <ShowLabel style={{ fontSize: "12px", margin: "0", color: statusStyle.color, fontWeight: "500" }}>
                  Reason:
                </ShowLabel>
                <ShowValue style={{ fontSize: "12px", margin: "0", color: statusStyle.color }}>
                  {record.cancellationReason}
                </ShowValue>
              </div>
            )}
            {record?.cancellationSubReason && (
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <ShowLabel style={{ fontSize: "12px", margin: "0", color: statusStyle.color, fontWeight: "500" }}>
                  Sub Reason:
                </ShowLabel>
                <ShowValue style={{ fontSize: "12px", margin: "0", color: statusStyle.color }}>
                  {record.cancellationSubReason}
                </ShowValue>
              </div>
            )}
          </div>
        )}
      </ButtonContainer>
    </WorkspaceHeader>
  );
};

function ChefForPartyShow() {
  const [selectedData, setSelectedData] = useState<any>(null);
  const [initiatedBy, setInitiatedBy] = useState<any>();
  const [openAssignCook, setOpenAssignCook] = useState(false);
  const [dishModel, setDishModel] = useState<boolean>(false);
  const [changeCouponModel, setChangeCouponModel] = useState<boolean>(false);
  const [cancelModel, setCancelModel] = useState<boolean>(false);
  const [reScheduleModel, setReScheduleModel] = useState<boolean>(false);
  const [updateCommentDialog, setUpdateCommentDialog] = useState(false);
  const [orderSummary, setOrderSummary] = useState(false);
  const [
    updateRemainingPaymentStatusDialog,
    setUpdateRemainingPaymentStatusDialog,
  ] = useState(false);
  const [addIngredientModel, setAddIngredientModel] = useState(false);
  const [updateOccasionModel, setUpdateOccasionModel] = useState(false);
  const [cookOrderSummary, setCookOrderSummary] = useState(false);
  const [addPreferencesModel, setAddPreferencesModel] = useState(false);
  const [oneMealTimeUpdateDialog, setOneMealTimeUpdateDialog] =
    useState<boolean>(false);
  const [openTagDailog, setOpenTagDialog] = useState<boolean>(false);
  const [updateOMSStatusDialog, setUpdateOMSStatusDialog] =
    useState<boolean>(false);

  return (
    <WorkspaceContainer>
      <Show
        actions={false}
        sx={{
          "& .RaShow-card": {
            boxShadow: "none",
            border: "none",
            backgroundColor: "transparent",
          },
        }}
      >
        <ChefForPartyHeaderWithRecord />

        <AssignCookOnChefForParty
          data={selectedData}
          open={openAssignCook}
          setOpen={setOpenAssignCook}
          
          trialId={"1"}
        />
        <ChangeOmsTimeDialog
          open={oneMealTimeUpdateDialog}
          setOpen={setOneMealTimeUpdateDialog}
          data={selectedData}
          forparty={true}
        />
        {changeCouponModel && (
          <ChangeCouponChefForPartyDialog
            data={selectedData}
            open={changeCouponModel}
            callback={() => {
              setChangeCouponModel(false);
            }}
          />
        )}
        {dishModel && (
          <EditDishesChefForParty
            data={selectedData}
            open={dishModel}
            callback={() => setDishModel(false)}
          />
        )}
        {cancelModel && (
          <ChefForPartyCancelDialog
            data={selectedData}
            open={cancelModel}
            callback={() => {
              setCancelModel(false);
            }}
          />
        )}
        {reScheduleModel && (
          <ChefForPartyReScheduleDialog
            data={selectedData}
            open={reScheduleModel}
            callback={() => {
              setReScheduleModel(false);
            }}
          />
        )}
        {orderSummary && (
          <ChefOrderSummaryDialog
            data={selectedData}
            open={orderSummary}
            callback={() => {
              setOrderSummary(false);
            }}
          />
        )}
        {cookOrderSummary && (
          <ChefOrderSummaryDialog
            data={selectedData}
            open={cookOrderSummary}
            callback={() => {
              setCookOrderSummary(false);
            }}
            forCook={true}
          />
        )}
        {addPreferencesModel && (
          <AddPartyPreferencesDialog
            data={selectedData}
            open={addPreferencesModel}
            callBack={() => setAddPreferencesModel(false)}
          />
        )}
        <UpdateCommentInChefForParty
          initiatedBy={initiatedBy}
          data={selectedData}
          open={updateCommentDialog}
          setOpen={setUpdateCommentDialog}
        />
        <UpdatePartyRemainingPaymentStatusDialog
          open={updateRemainingPaymentStatusDialog}
          setOpen={setUpdateRemainingPaymentStatusDialog}
        />
        <UpdateOMSStatusDialog
          open={updateOMSStatusDialog}
          setOpen={setUpdateOMSStatusDialog}
          forParty={true}
        />

        {addIngredientModel && (
          <AddIngredientDialog
            open={addIngredientModel}
            callback={() => setAddIngredientModel(false)}
            data={selectedData}
          />
        )}
        {updateOccasionModel && (
          <UpdateOccasionDialog
            open={updateOccasionModel}
            callback={() => setUpdateOccasionModel(false)}
            data={selectedData}
          />
        )}
        {openTagDailog && (
          <UpdateLeadTagDialog
            open={openTagDailog}
            setOpen={() => setOpenTagDialog(false)}
            data={selectedData}
          />
        )}

        <CTAButtons
          setOpenTagDialog={setOpenTagDialog}
          setSelectedData={setSelectedData}
          setOpenAssignCook={setOpenAssignCook}
          setDishModel={setDishModel}
          setCancelModel={setCancelModel}
          setReScheduleModel={setReScheduleModel}
          setInitiatedBy={setInitiatedBy}
          setUpdateCommentDialog={setUpdateCommentDialog}
          setChangeCouponModel={setChangeCouponModel}
          setOrderSummary={setOrderSummary}
          setUpdateRemainingPaymentStatusDialog={
            setUpdateRemainingPaymentStatusDialog
          }
          setAddIngredientModel={setAddIngredientModel}
          setUpdateOccasionModel={setUpdateOccasionModel}
          setCookOrderSummary={setCookOrderSummary}
          setAddPreferencesModel={setAddPreferencesModel}
          setOneMealTimeUpdateDialog={setOneMealTimeUpdateDialog}
          setUpdateOMSStatusDialog={setUpdateOMSStatusDialog}
        />
        <br />
        <ChefForPartyTab />
      </Show>
    </WorkspaceContainer>
  );
}

export default ChefForPartyShow;
